export const blueLinkStates = {
  $nest: {
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.8,
    },
  },
};

export const grayLinkStates = {
  $nest: {
    '&:hover': {
      opacity: 0.8,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
};
